<template>
  <v-dialog
    v-model="dialog"
    :width="showDone? '330px': '510px'">
    <div class="dialog-container">
      <h3>Adjust Policy</h3>
      <p v-if="dialogType === 0">This policy has been adjusted. All documents will be regenerated.</p>
      <section v-else-if="status !== 0">
        <!-- cheque done -->
        <p v-if="status === 1">This policy has been adjusted, and the amount refunded has been added to this policy's cheque queue.</p>
        <!-- credits done -->
        <p v-else-if="status === 2">This policy has been adjusted, and the amount refunded has been added to the customer's credits.</p>
        <!-- need payment done -->
        <p v-else>An adjustment quote has been added to the customer account. The policy will be adjusted when it has been paid.</p>
      </section>
      <p v-else-if="dialogType === 1">
        Do you want to refund via cheque, or add to the customer’s credits?
      </p>
      <p v-else-if="dialogType === 2">
        An adjustment quote will be added to the customer’s account, and the policy will be adjusted when it’s paid. Continue?
      </p>

      <div v-if="showDone">
        <v-button
          type="primary"
          @click="onDone">Done</v-button>
      </div>
      <div
        v-else-if="dialogType === 1"
        class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="onCheque">Cheque</v-button>
        <v-button
          type="primary"
          @click="onCredits">Credits</v-button>
      </div>
      <div
        v-else
        class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="onContinue">Continue</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { saveAdjustEdit } from '@/api/endorsement'
export default {
  name: 'AdjustRefundDialog',
  props: {
    dialogType: {
      type: Number,
      default: 0
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    premiumForm: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      //   dialogType: 0, // 0 - 正常， 1 - refund， 2 - need payment
      status: 0, // 2-credits, 1-cheque, 3 - need payment
      resultData: {}
    }
  },
  computed: {
    showDone() {
      if(this.dialogType !== 0 && this.status === 0) {
        return false
      }
      return true
    }
  },
  methods: {
    changeDialog(data = null) {
      this.dialog = !this.dialog
      if(data) {
        this.resultData = data
      }
    },
    onDone() {
      this.$emit('done', this.resultData)
      this.dialog = false
    },
    onCheque() {
      this.network().saveAdjustEdit({
        refund_type: 1
      })
    },
    onCredits() {
      this.network().saveAdjustEdit({
        refund_type: 2
      })
    },
    onContinue() {
      this.network().saveAdjustEdit()
    },
    network() {
      return {
        saveAdjustEdit: async (params = {}) => {
          // 退款類型 2：Credit; 1: Cheque (退款時必傳)
          delete this.formData.credit
          const { data } = await saveAdjustEdit({
            application: {
              ...this.formData,
              order_id: this.orderId,
            },
            premium: this.premiumForm,
            ...params
          })
          const { refund_type = 3 } = params
          this.status = refund_type
          this.resultData = data.data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      h3 {
          padding-bottom: 5px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
    }
</style>